export default __webpack_public_path__ + "static/media/644.a1d09f99.png";